import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { SpaceOptions } from '../../../theme/UiThemeProvider'

const shadow = {
  shadowColor: '#00000029',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 1,
  shadowRadius: 0,
}

const styles = {
  container: {
    underlayColor: 'TRANSPARENT',
    direction: 'row',
    align: 'center',
    justify: 'space-between',
    // paddingVertical: 'MEDIUM_BIG',
    paddingHorizontal: 'BIG',
    borderRadius: 2,
  } as BoxProps,
  creditCardContainer: {
    direction: 'column',
  } as BoxProps,
  cardCount: {
    position: 'absolute',
    bg: 'BG_PRIMARY_BUTTON',
    width: '15px',
    height: '15px',
    borderRadius: '7.5px',
    justify: 'center',
    align: 'center',
    right: -5,
  } as BoxProps,
  listItemContainer: {
    underlayColor: 'TRANSPARENT',
    direction: 'column',
    paddingHorizontal: 'BIG',
    pv: 6,
  } as BoxProps,
  listButton: {
    pv: 'MEDIUM',
    // borderWidth: 1,
    direction: 'row',
    // align: 'center',
    justify: 'space-between',
  } as BoxProps,
  leftContainer: {
    // flex: 0.4,
    // borderWidth: 1,
    direction: 'row',
    // align: 'center',
    // height: 80,
  } as BoxProps,
  cardIconContainer: {
    borderRadius: '4px',
    width: '40px',
    height: '24px',
    justify: 'center',
    align: 'center',
    borderWidth: 1,
    marginTop: 4,
    borderColor: 'BRAND_COLOR_GRAY_3',
    ...shadow,
  } as BoxProps,
  emptyContainer: () =>
    ({
      borderRadius: '8px',
      width: '48px',
      height: '32px',
      justify: 'center',
      align: 'center',
    } as BoxProps),
  cvvFormContainer: {
    flexWrap: 'wrap',
    direction: 'row',
    align: 'center',
  } as BoxProps,
  bsContainer: {
    paddingHorizontal: '50px' as SpaceOptions,
  } as BoxProps,
  bsContainerMobile: (theme: any) =>
    ({
      paddingHorizontal: 'LARGE',
      paddingVertical: 16,
      bg: theme?.bodyBgColor as ColorOptions,
    } as BoxProps),
  bsContainerMobileTop: (theme: any) =>
    ({
      backgroundColor: theme?.bodyBgColor as ColorOptions,
      paddingHorizontal: 'LARGE',
      paddingTop: 16,
    } as BoxProps),
  bsContainerMobileBottom: (theme: any) =>
    ({
      backgroundColor: theme?.bodyBgColor as ColorOptions,
      paddingHorizontal: 'LARGE',
      paddingBottom: 16,
    } as BoxProps),
  scrollStyle: {
    flexShrink: 1,
  },
}

export { styles }
